module Sm.UI.Components.Login

open Fable.React
open Fable.React.Props
open MobF.React

open Sm.UI.Form
open Sm.UI.Form.Basic
open Sm.UI.Login

open Sm.UI.Components.Control

[<ObserverComponent>]
let Fieldset (props: {| Form: BasicForm; Key: string |}) =
    let form = props.Form

    fragment [] [
        for i, field in form.State.Fields |> Seq.indexed do
            label [HtmlFor field.Name] [str field.Label]
            
            input [
                Type field.Type
                Name field.Name
                Title field.Label
                Value field.Value

                if field.Type = "email" then
                    AutoComplete "username"
                elif field.Type = "password" then
                    AutoComplete "current-password"

                if i = 0 then
                    AutoFocus true

                if form.Computed.Submitting then
                    Disabled true

                OnInput (fun e ->
                    let msg = EditField (field.Name, e.Value)
                    form.Post(msg)
                )
            ]

        renderButton form.Computed.Submit form.Post
    ]

[<ObserverComponent>]
let Login (props: {| Login: LoginModel |}) =
    let login = props.Login

    div [Id "login"] [
        div [Class "banner"] [
            iconFor BannerLogo []
        ]

        for message in login.Computed.Messages do
            div [Class "message"] [str message]

        form [OnSubmit (fun e -> e.preventDefault ())] [
            match login.Computed.Title with
            | None -> nothing
            | Some text -> h2 [] [str text]

            match login.State.Step with
            | Unknown -> nothing
            | Instruction message ->
                p [] [str message]
            | Form (action, form) -> 
                Fieldset {| 
                    Form = form
                    Key = string action 
                |}

            for transition in login.Computed.Transitions do
                renderButton transition login.Post
        ]
    ]
